import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {getLoginStatus} from '../reducers/login';
// import {hasGivenPrivacyConsent} from '../reducers/user';
import {LOGIN, PRIVACY} from './routes';

export function isAuthenticated(state) {
  return getLoginStatus(state) === 'ok';
}

export function buildPrivateRoute(store) {
  return function PrivateRoute({component, ...rest}) {
    return (
      <Route
        {...rest}
        render={props => {
          const state = store.getState();

          if (!isAuthenticated(state)) {
            return (
              <Redirect
                to={{
                  pathname: LOGIN,
                  state: {from: props.location},
                }}
              />
            );
          }

          // if (!hasGivenPrivacyConsent(state)) {
          //   return (
          //     <Redirect
          //       to={{
          //         pathname: PRIVACY,
          //         state: {from: props.location}
          //       }}
          //     />
          //   );
          // }s

          return React.createElement(component, {...props, ...rest});
        }}
      />
    );
  };
}

export function getFromLocation(state) {
  return state.getIn(['router', 'location', 'state', 'from', 'pathname']);
}
